import { FC } from 'react';
import { clsx } from 'clsx';
import { Tile } from '../interfaces/tile';
import { TileWrapper } from '../TileWrapper/TileWrapper';
import styles from './TileGrid.module.scss';

export interface TileGridProps<D extends object = object, T extends Tile<D> = Tile<D>> {
  tiles: Array<T>;
  onTileClick: (tile: T) => void;
  TileComponent?: FC<{ tile: T }>;
  tileComponentProps?: ((tile: T) => T) | T;
  className?: string;
}

export function TileGrid<D extends object = object, T extends Tile<D> = Tile<D>>({
  tiles,
  onTileClick,
  TileComponent,
  tileComponentProps,
  className
}: TileGridProps<D, T>) {
  return (
    <div className={clsx(styles.tilesGrid, className)} role='grid'>
      {tiles.map(tile => (
        <TileWrapper<T> key={tile.id} tileWidth='100%' tile={tile} onClick={onTileClick}>
          {TileComponent ? (
            <TileComponent
              tile={tile}
              {...(typeof tileComponentProps === 'function'
                ? tileComponentProps(tile)
                : tileComponentProps)}
            />
          ) : null}
        </TileWrapper>
      ))}
    </div>
  );
}
